<template>
   <div>
      <switch-hold-header :supplier-name="switchHold.supplierName" :reference-number="switchHold.referenceNumber"
         :completion-date="switchHold.completionDate"></switch-hold-header>
   </div>
</template>

<script>
import SwitchHoldHeader from '@/components/switch-hold-header/SwitchHoldHeader';
import { mapState } from 'vuex';

export default {
   name: 'SwitchHold',
   computed: {
      ...mapState({
         switchHold: ({ storage }) => storage.switchHold,
         app_settings: ({ app_settings }) => app_settings
      })
   },
   components: {
      SwitchHoldHeader
   }
};
</script>

<style lang="scss"></style>
